import { wpFetch } from 'src/helpers/wpApiHandler';

const useUpdateLeadCard = async (bodyData) => {
  const response = await wpFetch(['update-lead'], {
    method: 'POST',
    body: bodyData,
  });

  return response;
};

export default useUpdateLeadCard;
